"use strict";

function helper(Handlebars) {
  /**
   * Registers a partial
   * @param  {String} name    Name of partial
   * @param  {Object} options 'option' object sent by handlebars
   * @return <no return value>
   */
  function partial(name, options) {
    Handlebars.registerPartial(name, options.fn(this));
  }
  Handlebars.registerHelper('partial', partial);
  return partial;
}
module.exports = helper;
